import ActivityDetailsText from "@/modules/lead-page/new/components/activity/activity-details-typography";
import UserNameTag from "@/modules/lead-page/new/components/activity/user-name-tag";
import { Stack, useTheme } from "@mui/material";

interface OwnersCommentDetailsProps {
  actorName: string | null;
  actorColor: string | null;
}

const OwnersCommentDetails = ({
  actorName,
  actorColor,
}: OwnersCommentDetailsProps) => {
  const theme = useTheme();

  return (
    <Stack direction="row" spacing={theme.nawy.spacing.xxs}>
      {actorName && <UserNameTag name={actorName} color={actorColor} />}
      <ActivityDetailsText>Added a comment</ActivityDetailsText>
    </Stack>
  );
};

export default OwnersCommentDetails;
